<template>
<div class="animated-fadeIn">
    <div class="topbar">
        <div class="d-flex justify-content-center">
            <div class="booking">
                <div class="weekSelector" v-on:click="previousWeek();"><span class="lnr lnr-chevron-left"></span></div>
                <p class="date">
                    <span class="week">
                        {{ weekdays.Monday.format('DD') }} - 
                        <span v-if="showWeekend">{{ weekdays.Sunday.format('DD') }}</span>
                        <span v-else>{{ weekdays.Friday.format('DD') }}</span>
                    </span><br>
                    <span class="month">{{ weekdays.Monday.locale('da').format('MMMM') }}</span>
                </p>
                <div class="weekSelector" v-on:click="nextWeek();"><span class="lnr lnr-chevron-right"></span></div>
                <div class="text-center mt-1">
                    <span class="lnr mr-1" v-bind:class="{ 'lnr-checkmark-circle text-success': showWeekend, 'lnr-cross-circle text-danger': !showWeekend }"></span><span class="link" v-on:click="showWeekend = !showWeekend">Vis weekend</span>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="booking mt-4">
            <div v-if="isLoading" class="mt-5">
                <div class="loader dark mx-auto"></div>
            </div>
            <div class="calender" v-else>
                <div class="row">
                    <div class="col-lg">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Mandag</p>
                                <p class="date">{{weekdays.Monday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Monday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Monday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Tirsdag</p>
                                <p class="date">{{weekdays.Tuesday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Tuesday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Tuesday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Onsdag</p>
                                <p class="date">{{weekdays.Wednesday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Wednesday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Wednesday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Torsdag</p>
                                <p class="date">{{weekdays.Thursday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Thursday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Thursday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Fredag</p>
                                <p class="date">{{weekdays.Friday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Friday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Friday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg" v-if="showWeekend">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Lørdag</p>
                                <p class="date">{{weekdays.Saturday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Saturday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Saturday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg" v-if="showWeekend">
                        <div class="day">
                            <div class="heading">
                                <p class="weekDay">Søndag</p>
                                <p class="date">{{weekdays.Sunday.format('DD/MM')}}</p>
                            </div>
                            <div class="appointments">
                                <appointment
                                v-for="appointment of appointments.Sunday"
                                v-bind:appointment="appointment"
                                :key="appointment.key"
                                @selectAppointment="selectAppointment">
                                </appointment>
                                <div class="text-center" v-if="appointments.Sunday.length == 0">
                                    <p class="noResults">Ingen ledige tider</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <modal name="reserveAppointment" class="modalConfirmBooking modal" height="auto">
                <div class="modal-header">
                    <h5 class="modal-title">Bekræft bookning</h5>
                    <button type="button" class="close" v-on:click="hideModal();" aria-label="Close">
                        <span class="lnr lnr-cross"></span>
                    </button>
                </div>
                <div class="modal-body" v-if="selectedAppointment">
                    <div class="form-group mt-0 mb-4">
                        <p class="date">
                            <span class="lnr lnr-calendar-full"></span>
                            {{ selectedAppointmentDate }}
                        </p>
                    </div>
                    <div class="form-group my-0">
                        <div class="row">
                            <div class="col-3">
                                <p><span>Start</span>{{ selectedAppointment.time_start.format('HH:mm') }}</p>
                            </div>
                            <div class="col-3">
                                <p><span>Slut</span>{{ selectedAppointment.time_end.format('HH:mm') }}</p>
                            </div>
                            <div class="col-3">
                                <p><span>Kategori</span>{{ selectedAppointment.category }}</p>
                            </div>
                            <div class="col-3">
                                <p><span>Tid</span>{{ selectedAppointmentDuration }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group my-0">
                        <p>
                            <span>Instruktør</span>
                            {{ selectedAppointment.instructor.name }}
                        </p>
                    </div>
                    <div class="form-group my-0" v-if="selectedAppointment.description">
                        <p>
                            <span>Beskrivelse</span>
                            {{ selectedAppointment.description }}
                        </p>
                    </div>
                    <div class="form-group">
                        <label><input type="checkbox" v-model="reserveNotify"> Send påmindelse til min e-mail</label>
                    </div>
                    <button type="button" class="btn btn-success btn-block mt-5" v-on:click="reserveAppointment();">
                        <span v-if="modalIsLoading"><div class="loader mx-auto"></div></span>
                        <span v-else>Book nu</span>
                    </button>
                </div>
            </modal>
        </div>
    </div>
</div>
</template>

<script>
import Appointment from '@/components/appointment/booking/Appointment.vue';


export default {
    components: {
        Appointment,
    },

    data: function() {
        return {
            weekdays: {
                Monday: '',
                Tuesday: '',
                Wednesday: '',
                Thursday: '',
                Friday: '',
                Saturday: '',
                Sunday: '',
            },

            appointments: {
                Monday: [],
                Tuesday: [],
                Wednesday: [],
                Thursday: [],
                Friday: [],
                Saturday: [],
                Sunday: [],
            },

            selectedAppointment: '',
            reserveNotify: true,
            modalIsLoading: false,

            showModal: false,
            showWeekend: false,

            isLoading: true,
        }
    },

    created: function() {
        this.setWeekdays();
        this.fetchAppointments();
    },

    computed: {
        selectedAppointmentDuration: function() {
            var duration = parseInt(this.selectedAppointment.duration);
            var durationString = '';
            
            if(duration > 60) {
                let hours = Math.trunc(duration/60);
                durationString = hours+'t ';
                duration -= 60*hours;
            }

            duration > 0 ? durationString += duration+'m':null;

            return durationString;
        },

        selectedAppointmentDate: function() {
            var date = this.$moment(this.selectedAppointment.date);
            return date.locale('da').format('dddd, DD/MM Y');
        },
    },

    methods: {
        fetchAppointments() {
            this.isLoading = true;
            
            this.appointments = {
                Monday: [],
                Tuesday: [],
                Wednesday: [],
                Thursday: [],
                Friday: [],
                Saturday: [],
                Sunday: [],
            };

            this.axios.get('school/appointments/'+this.weekdays.Monday.format('DDMMYY')+'/'+this.weekdays.Sunday.format('DDMMYY'))
                .then(res => {
                    var appointments = res.data;

                    appointments.forEach(appointment => {
                        let weekday = this.$moment(appointment.date).format('dddd');
                        this.appointments[weekday].push(appointment);
                    });

                    this.isLoading = false;
                });
        },

        selectAppointment(appointment) {
            this.selectedAppointment = appointment;
            this.$modal.show('reserveAppointment');
        },

        reserveAppointment() {
            var appointment = this.selectedAppointment;
            this.modalIsLoading = true;
            
            this.axios.post('appointments/'+appointment.id+'/reserve', {
                    notify: this.reserveNotify,
                })
                .then(res => {
                    let appointments = this.appointments[appointment.date.format('dddd')];
                    let indexOfAppointment = appointments.indexOf(appointment);

                    appointments.splice(indexOfAppointment, 1);

                    this.modalIsLoading = false;
                    this.$modal.hide('reserveAppointment'); 

                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'Bookning bekræftet!',
                        text: 'Din bookning blev bekræftet.',
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.modalIsLoading = false;
                });
        },

        setWeekdays() {
            var today = this.$moment();
            
            if(today < this.$moment().day(5)) {
                this.weekdays = {
                    Monday: this.$moment().day(1),
                    Tuesday: this.$moment().day(2),
                    Wednesday: this.$moment().day(3),
                    Thursday: this.$moment().day(4),
                    Friday: this.$moment().day(5),
                    Saturday: this.$moment().day(6),
                    Sunday: this.$moment().day(7),
                };
            } else {
                this.weekdays = {
                    Monday: this.$moment().day(1).add(7, 'days'),
                    Tuesday: this.$moment().day(2).add(7, 'days'),
                    Wednesday: this.$moment().day(3).add(7, 'days'),
                    Thursday: this.$moment().day(4).add(7, 'days'),
                    Friday: this.$moment().day(5).add(7, 'days'),
                    Saturday: this.$moment().day(6).add(7, 'days'),
                    Sunday: this.$moment().day(7).add(7, 'days'),
                };
            }
        },

        nextWeek() {
            var weekdays = this.weekdays;

            for(var property in weekdays) {
                weekdays[property].add(7, 'days');
            }

            this.fetchAppointments();
        },

        previousWeek() {
            var weekdays = this.weekdays;

            for(var property in weekdays) {
                weekdays[property].subtract(7, 'days');
            }

            this.fetchAppointments();
        },

        hideModal() {
            this.$modal.hide('reserveAppointment');
        },
    }
}
</script>

